import { APPS_ROUTES } from '../../screens/apps/routes';

export const qrCode = {
  id: 'qr_code',
  name: 'QR code generator',
  icon: 'fas fa-qrcode',
  kind: 'web',
  tagline: 'Create a QR code in your browser.',
  summary: 'Generate QR codes for links or plain text without uploads. Everything runs locally in your browser.',
  route: APPS_ROUTES.qrCode,
  badges: [
    { label: 'Web tool', variant: 'accent' },
    { label: 'Runs locally', variant: 'river' },
    { label: 'No data upload', variant: 'outline' },
  ],
  release: {
    label: 'Available now',
  },
  features: [
    {
      id: 'browser-generation',
      title: 'Local generation',
      body: 'The QR image is generated in your browser session. Nothing you type is sent to a backend service.',
    },
    {
      id: 'png-download',
      title: 'PNG export',
      body: 'Download the generated QR code as a PNG image created locally from an offscreen canvas.',
    },
  ],
};
